import ModalDialog from '@ui/modal/ModalDialog';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
const MbmAccordionTab = (props) => {
    var _a;
    const { t } = useTranslation();
    const [openPalette, setOpenPalette] = useState();
    const createTitleMarkup = (palette) => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mbm-palette" },
            React.createElement("span", null, palette.name),
            React.createElement("img", { src: palette.paletteImage.path, alt: "" }))));
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "primary-m" }, t('mbm.accordion1')),
        React.createElement("ul", { className: "mbm-list" },
            React.createElement(Accordion, null, (_a = props.palettes) === null || _a === void 0 ? void 0 : _a.map((palette, i) => (React.createElement(AccordionItem, { autoHeight: true, title: createTitleMarkup(palette), isTitleMarkup: true, headerClass: "accordion__header--uc", accordionId: "mbm", key: i },
                React.createElement("div", { className: "palette-accordion row" },
                    React.createElement("div", { className: "palette-accordion-body col-md-6 col-12" },
                        React.createElement("h3", { className: "primary-s mb-16" }, palette === null || palette === void 0 ? void 0 : palette.subtitle),
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: palette === null || palette === void 0 ? void 0 : palette.text } })),
                    React.createElement("div", { className: "aspect-ratio--3-4 palette-modal__image col-md-6 col-12" },
                        React.createElement("img", { src: palette === null || palette === void 0 ? void 0 : palette.image.path, alt: "" })))))))),
        React.createElement("p", { className: "primary-m" }, t('mbm.accordion2')),
        React.createElement(ModalDialog, { hideHeader: true, noPadding: true, isOpen: !!openPalette, onRequestClose: () => setOpenPalette(undefined), id: "palette-modal" })));
};
export default MbmAccordionTab;
